import { Box } from '@eatclub-apps/ec-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

/**
 * An image that just fits. Will stretch or shrink to fit within the width and height provided without stretching
 * @param url
 * @param altText
 * @param width
 * @param height
 * @param style
 * @returns {JSX.Element}
 * @constructor
 */
const FittedImage = ({ url, altText, width, height, style }) => {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        flex: 'auto',
        aspectRatio: `${width} / ${height}`,
        height: '100%',
        minWidth: 0,
        minHeight: 0,
        flexShrink: 0,
      }}
    >
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          // flex: 'auto',
          width: '100%',
          // aspectRatio: '600 / 420',
          minWidth: 0,
          minHeight: 0,
          flexShrink: 0,
          maxHeight: `${height}px`,
        }}
      >
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // height: '100%',
            minWidth: 0,
            minHeight: 0,
            // height: 'fit-content',
            flexShrink: 0,
            maxWidth: `${width}px`,
            maxHeight: 'fit-content',
          }}
        >
          <img
            style={{
              width: '100%',
              height: '100%',
              maxWidth: `${width}px`,
              maxHeight: `${height}px`,
              borderRadius: '8px',
              flexShrink: 0,
              objectFit: 'contain',
              ...style?.image,
            }}
            src={url}
            alt={altText}
          />
        </Box>
      </Box>
    </Box>
  );
};

FittedImage.defaultProps = {
  style: { image: {} },
};

FittedImage.propTypes = {
  url: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  style: PropTypes.shape({ image: PropTypes.shape({}) }),
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FittedImage);
